/**
 * Permet à l'utilisateur de s'authentifier
 * @type {string}
 */
export const USER_LOGIN = 'login'

/**
 * Rafraichit le token de l'utilisateur
 * @type {string}
 */
export const USER_TOKEN_REFRESH = 'refreshToken'

/**
 * Permet de mettre fin à la session
 * @type {string}
 */
export const USER_LOGOUT = 'logout'

/**
 * Permet de mettre à jour l'utilisateur
 * @type {string}
 */
export const USER_PUT_USER = 'putUser'

/**
 * Récupère les infos de l'utilisateur courant
 * @type {string}
 */
export const USER_FETCH_USER = 'fetchUser'

/**
 * Permet d'altérer le profil
 * @type {string}
 */
export const USER_ALTERATE_PROFILE = 'alterateProfile'

/**
 * Permet d'altérer l'agence
 * @type {string}
 */
export const USER_ALTERATE_AGENCY = 'alterateAgency'

/**
 * Permet de mettre à jour l'agence
 * @type {string}
 */
export const USER_PUT_AGENCY = 'putAgency'

/**
 * Permet de mettre à jour la formule de l'agence
 * @type {string}
 */
export const USER_PATCH_AGENCY_PLAN = 'patchAgencyPlan'
